const OrderFlowExceptionTypes = {
    MENU_ITEM_INACTIVE: "MENU_ITEM_INACTIVE",
    MODIFIER_INACTIVE: "MODIFIER_INACTIVE"
}

export default OrderFlowExceptionTypes